import {TranslateService} from '@ngx-translate/core';
import reverse from 'lodash-es/reverse';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';
import {KeyMetricsTable} from '../../key-metrics.table';

import {Column} from './column';

export class BasicBar extends Column {
  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService,
              public isInside: boolean) {
    super(chart, translate, localization);

    this.chart.data = reverse(this.monthSortData(this.chart.data));

    this.tooltip = this.getTooltip((value) => value.seriesName, false);

    this.legend = {
      data: this.sortCategories(this.chart.data.map(item => item.name))
    };

    this.xAxis = [
      {
        type: 'value',
        axisLabel: {
          formatter: (value) => this.localization.localizeNumber(value, 'DECIMAL_2_DIGIT')
        }
      }
    ];

    this.categories = this.getCategories('category', this.chart.accus1);

    this.yAxis = {
      position: 'right',
      type: 'category',
      data: this.categories,
      axisLabel: {
        show: true,
        formatter: (value) => this.translate.instant(value)
      },
      axisTick: {
        show: false
      }
    };

    if (this.isInside) {
      this.yAxis.z = 100;
      this.yAxis.position = 'left';
      this.yAxis.axisLabel.align = 'left';
      this.yAxis.axisLabel.margin = 0;
      this.yAxis.axisLabel.padding = 4;
    } else {
      this.grid = {
        x: 30,
        x2: 200
      };
    }

    const columns: string[] = this.categories.map((column: string) => this.translate.instant(column));
    this.table = new KeyMetricsTable([], columns, this.categories, []);

    this.getPeriodAggregateData(this.categories, 'name', 'category')
      .forEach((elementArray: number[], key: string) => {
        this.series.push({
          type: 'bar',
          name: key,
          data: elementArray
        });
        this.pushTableRow(key, elementArray);
      });
  }

  public pushTableRow(key: string, elementArray: number[]): void {
    this.table.addRowHeader(this.translate.instant(key));
    this.table.addData(elementArray
      .map((dataElement: number) => this.localization.localizeNumber(dataElement, 'DECIMAL_2_DIGIT'))
    );
  }

  public createLoadView(withTitle: boolean, withLabel: boolean): void {
    this.yAxis.axisLabel.padding = 15;
    super.createLoadView(withTitle, withLabel);
  }

  public resetChart(): void {
    this.yAxis.axisLabel.padding = 4;
    super.resetChart();
  }
}
